export default __webpack_public_path__ + "static/media/breeding-image.a128bf24.png";